<template>
  <page :title="title" :breadcrumb="breadcrumb">
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <v-btn text color="secondary" v-on="on">
            More Links...
            <v-icon right>mdi-link</v-icon>
          </v-btn>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <v-card>
      <!-- <v-card-title v-if="!newGSTMap">
        <div class="title">{{gstApplnInt}} - {{getGSTApplnInt(gstApplnInt)}}</div>
      </v-card-title> -->
      <transition name="slide-x-transition" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-card>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { gstApplnInt } from '@/const/acct/gst'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
export default {
  data() {
    return {
      title: 'GST Mapping Query',
      breadcrumb: [],
      sideFunction: [
        {
          text: 'GST Mapping',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'gstMapQueryDet' }
        },
        {
          text: 'GST Interface',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'gstIntQuery' }
        }
      ]
    }
  },
  created() {
    const jsonData = JSON.parse(sessionStorage.getItem('gstMap'))
    if (jsonData) {
      this.$store.commit('GSTMAP_COMMIT_KEY', jsonData)
    }
    this.doInit()
  },
  methods: {
    doInit() {
      this.doBreadcrumb()
    },
    doBreadcrumb() {
      switch (this.$route.name) {
        case 'gstMapQueryDet': {
          this.breadcrumb = this.derieveBreadcrumbByName('gstMapQueryDet')
          this.title = 'GST Mapping Query'
          break
        }
        case 'gstIntQuery': {
          this.breadcrumb = this.derieveBreadcrumbByName('gstIntQuery')
          this.title = 'GST Interface Query'
          break
        }
      }
    },
    getGSTApplnInt(value) {
      return gstApplnInt[value]
    }
  },
  beforeRouteLeave(to, from, next) {
    sessionStorage.removeItem('gstMap')
    next()
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName']),
    menu() {
      return this.$store.state.gstParam.menu
    },
    newGSTMap() {
      return this.gstApplnInt === 'new'
    }
  },
  watch: {
    '$route.name'(value) {
      this.doBreadcrumb()
    },
    gstApplnInt(value) {
      this.doInit()
    }
  },
  components: {
    SideFunctionMenu
  },
  props: ['gstApplnInt']
}
</script>

<style>
</style>
